// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1H73L","label":"Radio_label__pSnTb","checkMark":"Radio_checkMark__ZbiTY","disabled":"Radio_disabled__3ddti"};